export const MIN_PRICE = 250000000
export const MAX_PRICE = 9000000000

export const MIN_AREA = 30
export const MAX_AREA = 1000

export const MIN_ADMINISTRATION = 0
export const MAX_ADMINISTRATION = 3000000
